export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      const {
        auth: { authToken }
      } = store.getState();

      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
      }

      if (config.url.includes("ChangePassword")) {
        const tempToken = JSON.parse(sessionStorage.accessToken);
        config.headers.Authorization = `Bearer ${tempToken}`;
      }

      config.timeout = 180000;

      return config;
    },
    err => Promise.reject(err)
  );


  axios.interceptors.response.use(response => {
    return response;
  }, error => {
    console.log("setupAxios Error");
    console.log(JSON.stringify(error));

    if (error.message.includes("Network Error")) {
      return Promise.reject(error);
    }
    // var res = error.message.includes("timeout of ");
    // console.log(res);
    if (error.message.includes("timeout of ")) {
      return Promise.reject(error);
    }
    //  console.log(error.response);
    if (error.response.status && error.response.status === 401) {
      window.localStorage.clear();
      window.location.replace("/auth/login");
      return Promise.reject(error);

    }

    return Promise.reject(error);

  });
}
